import { useState } from 'react';
import BookingModal from './BookingModal';
import home from '../Images/home.jpg';
import consultation from '../Images/consultation.jpg';
import global from '../Images/global.jpg';
import cardio from '../Images/cardio.jpg';
import neurology from '../Images/neurology.jpg';
import ortho from '../Images/ortho.jpg';
import paediatrics from '../Images/Paediatrics.jpg';
import medicine from '../Images/Sports Medicine.png';
import geriatrics from '../Images/Geriatrics.jpg';
import helath from '../Images/Womens Health.jpg';
import oncology from '../Images/Oncology.jpg';
import ServiceCard from './ServiceCard';
import './Services.css';

const services = [
    {
        title: "Home Visit",
        image: home,
        details: [
            "Certified Experts at Your Doorstep: Licensed physiotherapists bring clinic-quality care to your home and office",
            "Zero Travel, Full Comfort: Skip the commute recover faster in your safest, most familiar environment",
            "Personalized Care: Treatments tailored to your space, lifestyle, and goals from post-surgery rehab to chronic pain relief",
            "Advanced Tools on Wheels: Portable electrotherapy, ultrasound, and manual therapy equipment for clinic-level results at home",
            "Family Involvement: Train caregivers during sessions for holistic recovery support",
        ],
    },
    {
        title: "Online Consultation",
        image: consultation,
        details: [
            " Virtual consultations for exercise guidance & progress reviews",
            "Tele-rehabilitation for remote monitoring",
            "Pain management sessions via video",
            "Customized exercise plans",
            "Second-opinion consultations",
        ],
    },
    {
        title: "Global Care for NRIs",
        image: global,
        details: [
            "Access India’s top therapists from any country, anytime",
            "Culturally sensitive care aligned with NRI lifestyles",
            "Time zone-friendly scheduling across continents",
            "Continuity of care during travel or relocation",
        ],
    },
    {
        title: "Musculoskeletal / Orthopaedic",
        image: ortho,
        details: [
            "Neck Pain",
            "Low Back Pain",
            "Frozen Shoulder",
            "Tennis Elbow",
            "Carpel Tunnel Syndrome",
            "Piriformis Syndrome",
            "IT Band Syndrome",
            "Osteoarthritis of Knee",
            "ACL, PCL, MCL, LCL, Meniscus Injury",
            "Hip & Knee Post-operative Rehabilitation",
            "Calcaneal Bursitis",
            "Ankle Pain"
        ],
    },
    {
        title: "Cardiopulmonary", image: cardio, details: ["Post Covid Rehabilitation",
            "Breathing exercise training",
            "Post-operative Rehabilitation",
            "Cardiac Rehabilitation",
            "Pulmonary Rehabilitation"
        ]
    },
    {
        title: "Neurology", image: neurology, details: ["Stroke",
            "Spinal cord injury",
            "GBS",
            "Parkinson",
            "Multiple sclerosis",
            "Bell’s palsy"
        ]
    },
    {
        title: "Paediatrics", image: paediatrics, details: ["Cerebral Palsy (CP)",
            "Delayed Milestone",
            "Muscular Dystrophy",
            "Spinal muscular atrophy",
            "Down syndrome"
        ]
    },
    {
        title: "Sports Medicine", image: medicine, details: ["Ligament Injury",
            "Ligament reconstruction rehabilitation",
            "Return to Sports",
            "Sports specific training"
        ]
    },
    {
        title: "Older People / Geriatrics", image: geriatrics, details: ["Fall prevention",
            "Gait Training",
            "Osteoporosis Exercises",
            "Arthritis Exercises",
            "General Fitness"
        ]
    },
    {
        title: "Women’s Health", image: helath, details: ["Pre and Post Natal exercises",
            "Urinary incontinence Exercises",
            "Pelvic floor Exercises"
        ]
    },
    { title: "Oncology", image: oncology, details: ["Cancer Rehab", "Fatigue Management"] },
];

function Services() {
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false); 

    const handleBookNow = () => {
        setIsModalOpen(true);
    };

    return (
        <section id="services" className="services-section">
            <h2>Our Services</h2>

            <div className="services-grid">
                {services.map((service, index) => (
                    <ServiceCard
                        key={index}
                        index={index}
                        title={service.title}
                        image={service.image}
                        details={service.details}
                        expanded={expandedIndex === index}
                        onToggle={() =>
                            setExpandedIndex(expandedIndex === index ? null : index)
                        }
                        onBookNow={handleBookNow} // 👈 pass handler to child
                    />
                ))}
            </div>

            {/* 👇 Modal rendered here */}
            <BookingModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </section>
    );
}


export default Services;
